// Copyright Abridged, Inc. 2021,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';
import {CommunityMemberInfo} from './community-member-info.model.js';
import {UserRoleAssignment} from './user-role-assignment.model.js';
import {TokenGrantedRole} from './token-granted-role.model.js';

/**
 * The model class is generated from OpenAPI schema - UserRoleAssignments
 * UserRoleAssignments
 */
@model({name: 'UserRoleAssignments'})
export class UserRoleAssignments {
  constructor(data?: Partial<UserRoleAssignments>) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'boolean',
    },
  })
  consistent?: boolean;

  /**
   *
   */
  @property({
    jsonSchema: {
      $ref: '#/components/schemas/CommunityMemberInfo',
    },
  })
  user?: CommunityMemberInfo;

  /**
   *
   */
  @property.array(UserRoleAssignment, {
    jsonSchema: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/UserRoleAssignment',
      },
    },
  })
  roles?: UserRoleAssignment[];

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  })
  errors?: string[];

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  })
  rolesFailed?: string[];

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  })
  accounts?: string[];

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'array',
      items: {
        type: 'object',
      },
    },
  })
  assets?: {}[];

  /**
   *
   */
  @property.array(TokenGrantedRole, {
    jsonSchema: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/TokenGrantedRole',
      },
    },
  })
  rules?: TokenGrantedRole[];

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  })
  currentRoles?: string[];

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'object',
      additionalProperties: {
        type: 'boolean',
      },
    },
  })
  rolesToApply?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [additionalProperty: string]: any;
  };

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'object',
      additionalProperties: {
        type: 'boolean',
      },
    },
  })
  resultsByRule?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [additionalProperty: string]: any;
  };
}

export interface UserRoleAssignmentsRelations {
  // describe navigational properties here
}

export type UserRoleAssignmentsWithRelations = UserRoleAssignments &
  UserRoleAssignmentsRelations;
